import React from "react";
import { Link } from "react-router-dom";

import logo from "assets/images/Logo.svg";
import { SidebarMenuLinks } from "components/Sidebar/components/SidebarMenuLinks";
import { pathGenerators } from "utils/routes";

import styles from "./SidebarDesktop.module.css";

export const SidebarDesktop = ({
  isActive,
  onMenuClick,
  userrole,
  isAdmin,
  hasAccess,
}) => (
  <div className={styles.sidebar}>
    <div className={styles.sidebarWrapper}>
      <Link
        className={styles.navbarBrand}
        to={pathGenerators.global.home()}
        onClick={onMenuClick}
      >
        <img src={logo} alt="logo" />
      </Link>
      <div className={styles.linksWrapper} data-testid="sidebar-nav">
        <SidebarMenuLinks
          styles={styles}
          isActive={isActive}
          onMenuClick={onMenuClick}
          userrole={userrole}
          isAdmin={isAdmin}
          hasAccess={hasAccess}
        />
      </div>
    </div>
  </div>
);
